import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import CustomSelect from './Select';

function SelectDemo() {
  const options = [
    { value: '1', label:"label for Menu item 1"  },
    { value: '2', label:"label for Menu item 2"  },
    { value: '3', label:"label for Menu item 3"  },
    { value: '4', label:"label for Menu item 4"  },
    { value: '5', label:"label for Menu item 5"  },
    { value: '6', label:"label for Menu item 6"  },
    { value: '7', label:"label for Menu item 7"  },
    { value: '8', label:"label for Menu item 8"  },
    { value: '9', label:"label for Menu item 9"  },
    { value: '10', label:"label for Menu item 10"  },
  ];

  return (
    <Container>
      <Container className="mt-10">
        <Row>
          <Col className="mt-10 p-0">
            <h4>Custom Select Input</h4>
            <Container className="d-flex justify-content-between flex-wrap mt-10 p-0">
              <CustomSelect options={options} label={'Sample label'} onChange={() => console.log("I'm changed")} className="me-4"/>
              <CustomSelect options={options} label={'Sample label'}  defaultOption={options[1]} className="me-4" />
              <CustomSelect options={options} label={'Sample label'} disabled className="me-4" />
              <CustomSelect options={options} label={'Sample label'} isValid className="me-4" />
              <CustomSelect options={options} label={'Sample label'} isInvalid />
            </Container>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default SelectDemo;
